import { Flex, Spinner } from '@chakra-ui/react';
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Home, MetaProcessingPage, PublishQaPage, WaveUploadPage } from '@/pages/index';

export const Routing: React.FC = () => {
  const LoadingFallback = () => (
    <Flex height="100vh" alignItems="center" justifyContent="center">
      <Spinner size="xl" color="blue.500" />
    </Flex>
  );

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Landing Page - No auth for now */}
        <Route path="/" element={<Home />} />
        <Route path="/wave-upload" element={<WaveUploadPage />} />
        <Route path="/meta-processing" element={<MetaProcessingPage />} />
        <Route path="/publish-qa" element={<PublishQaPage />} />

        {/* Catch all - redirect to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
